import { Link } from "react-router-dom";
import React, { useState } from "react";
import { HiOutlineLogin, HiOutlineUser, HiPlus } from "react-icons/hi";
import { Offcanvas, Spinner } from "react-bootstrap";
import { ImList2 } from "react-icons/im";
import { useMainLayout } from "./Hooks/index";
import Loading from "../Components/Loading";
import {
  BsInstagram,
  BsTelegram,
  BsWhatsapp,
  BsLinkedin,
} from "react-icons/bs";
import { TfiEmail } from "react-icons/tfi";
const WebLayout = ({ children }) => {
  const { isLogin, loading, mainData, form, setForm, sendEmail, loadingbtn } = useMainLayout();
  const [show, setShow] = useState(false);
  const toggler = () => setShow(!show);
  const links = [
    {
      label: "همه آگهی ها",
      route: "/ads/all",
      icon: <ImList2 />,
      className: "mr-53",
    },
    {
      label: "مقالات",
      route: "/blogs",
    },
    {
      label: "تماس با ما",
      route: "/contact-us",
    },
    {
      label: "درباره ما",
      route: "/about-us",
    },
    {
      label: "قوانین و مقررات",
      route: "/terms",
    },
  ];
  const renderBlog = () => {
    if (loading) {
      return (
        <div className="row">
          <Loading col={7} count={4} height={"20px"} />
        </div>
      );
    } else {
      return mainData?.last_blog?.map(blog => {
        return (
          <div>
            <Link to={"/Blogs/" + blog.slug}>{blog.title}</Link>
          </div>
        );
      });
    }
  };
  return (
    <div className="body">
      <nav className="navbar navbar-expand-lg">
        <Link className="navbar-brand" to="/">
          <img src={require("../Assets/images/logo.png")} className="logoHeader" />
        </Link>
        <button className="navbar-toggler" onClick={toggler}>
          <span className="navbar-toggler-icon" />
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav" style={{ gap: "20px" }}>
            {links.map(link => {
              return (
                <li className="nav-item active">
                  <Link
                    className={"nav-link " + link.className}
                    to={link.route}
                  >
                    {link.label}
                  </Link>
                </li>
              );
            })}
          </ul>
          <div className="d-flex align-items-center">

            <Link className="new-add new-add-ouline ms-2" to={"/ads/all?category_parent_id=74"}>
              مزایده و مناقصه
            </Link>
            <span className="lineCol"></span>

            {isLogin() &&
              <Link className="new-add ms-2" to={"/ads-submit"}>
                <HiPlus />
                <span>ثبت آگهی جدید</span>
              </Link>
            }

            <Link
              className="new-add "
              to={isLogin() ? "/dashboard" : "/login"}>
              {isLogin() ? (
                <>
                  <HiOutlineUser className="wSvg" />
                  <span>پنل کاربری</span>
                </>
              ) : (
                <>
                  <HiOutlineLogin className="wSvg" />
                  <span>ورود / ثبت نام</span>
                </>
              )}
            </Link>

          </div>
        </div>
      </nav >
      <div className="web-content">{children}</div>
      <footer>
        <div className="container">
          <div className="d-flex align-items-center justify-content-center mb-5 topFooter">
            <img src={require("../Assets/images/logo.png")}
              style={{ width: "109px", height: "74px", objectFit: "contain" }} />

            <h6 className="me-3">نیازمندی های رایگان صنعت</h6>

          </div>
          <div className="row ">
            <div className="col-md-3 mb-lg-0 mb-3">
              <div>
                <h4 className="titleItems">راه های ارتباطی</h4>
              </div>
              <div className="footer-row">
                <span>تلفن پشتیبانی: </span>
                {loading ? (
                  <Loading height={"20px"} col={"6"} />
                ) : (
                  <p>{mainData?.contact_us?.support_number} </p>
                )}
              </div>
              <div className="footer-row">
                <span>ایمیل: </span>
                {loading ? (
                  <Loading height={"20px"} col={"6"} />
                ) : (
                  <p>{mainData?.contact_us?.email} </p>
                )}
              </div>
              <div className="footer-row">
                <span>فکس: </span>
                {loading ? (
                  <Loading height={"20px"} col={"6"} />
                ) : (
                  <p>{mainData?.contact_us?.fax} </p>
                )}
              </div>
              <div className="mb-13">
                <span>آدرس: </span>
                {loading ? (
                  <Loading height={"20px"} />
                ) : (
                  <p>{mainData?.contact_us?.addres} </p>
                )}
              </div>
            </div>
            <div className="col-md-3 mb-lg-0 mb-3 col-6">
              <h4 className="titleItems">لینک های مهم</h4>
              <div>
                <Link to={"/"}>آخرین آگهی ها</Link>
              </div>
              <div>
                <Link to={"/"}>آگهی های مشهد</Link>
              </div>
              <div>
                <Link to={"/"}>آگهی های تهران</Link>
              </div>
              <div>
                <Link to={"/contact-us"}>تماس با ما</Link>
              </div>
              <div>
                <Link to={"/about-us"}>درباره ما</Link>
              </div>
              <div>
                {/* <Link to={"/terms"}>قوانین و مقررات</Link> */}
              </div>
            </div>
            <div className="col-md-3  col-6">
              <div>
                <h4 className="titleItems">آخرین مقاله ها</h4>
                {renderBlog()}
              </div>
            </div>
            <div className="col-md-3 mb-lg-0 mb-3">
              <div className="subscribe-input mb-lg-0 mb-3">
                <TfiEmail style={{ fontSize: "25px", paddingRight: "5px" }} />
                <input
                  placeholder="ایمیل خود را وارد کنید"
                  onChange={e => {
                    setForm({ ...form, email: e.target.value });
                  }}
                  value={form.email}
                />
                <button onClick={() => sendEmail()}>
                  {loadingbtn ? <Spinner size="sm" /> : "ثبت"}{" "}
                </button>
              </div>

              <div className="social-media-wrapper mt-4 mb-lg-0 mb-3">
                <h5>همراه صنعتبان باشید</h5>
                <div className="d-flex mt-3">
                  <div className="">
                    <a href={mainData?.social_media?.instagram}>
                      <BsInstagram style={{ fontSize: "20px" }} />
                    </a>
                  </div>
                  <div className="me-3">
                    <a href={mainData?.social_media?.linkedin}>
                      <BsLinkedin style={{ fontSize: "20px" }} />
                    </a>
                  </div>
                  <div className="me-3">
                    <a href={mainData?.social_media?.telegram}>
                      <BsTelegram style={{ fontSize: "20px" }} />
                    </a>
                  </div>
                  <div className="me-3">
                    <a href={mainData?.social_media?.whatsapp}>
                      <BsWhatsapp style={{ fontSize: "20px" }} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copy-right">
          <p className="ft-15">
            طراحی و توسعه: شرکت ویداسیستم ایرانیان - تلفن تماس: 02191027127
          </p>
        </div>
      </footer>
      <Offcanvas
        placement="end"
        show={show}
        onHide={toggler}
        className="drawer"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <img src={require("../Assets/images/logo.png")} className="miniLogHeader" />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="links-drawer">
            {links.map(link => {
              return <Link to={link.route}>{link.label}</Link>;
            })}
            <div className="profilebtnBox">
              <Link className="new-add new-add-ouline ms-2" to={"/ads/all?category_parent_id=74"}>
                مزایده و مناقصه
              </Link>

              {isLogin() &&
                <Link className="new-add ms-3 " to={"/ads-submit"}>
                  <HiPlus />
                  <span>ثبت آگهی جدید</span>
                </Link>
              }

              <Link className="new-add " to={isLogin() ? "/dashboard" : "/login"}>
                {isLogin() ? (
                  <>
                    <HiOutlineUser className="me-2" width={20} />
                    <span>پنل کاربری</span>
                  </>
                ) : (
                  <>
                    <HiOutlineLogin className="me-2" width={20} />
                    <span>ورود / ثبت نام</span>
                  </>
                )}
              </Link>

            </div>

          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div >
  );
};

export default WebLayout;
